import ApiService from "@/common/api.service";

export const AccreditationSummaryService = {
    getAccreditationSummary() {
        return ApiService.get("/accreditationSummaryReport");
    },
    getAccreditationSummaryWP(query) {
        let queryParam = `/accreditationSummaryReport${query}`;
        return ApiService.get(queryParam);
    },
};
